export default function deleteS3Object(key: String) {
  const AWS = require('aws-sdk');

  const access = new AWS.Credentials({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  });

  const s3 = new AWS.S3({
    credentials: access,
    region: 'eu-west-1',
    signatureVersion: "v4",
  });

  var params = { Bucket: process.env.REACT_APP_ASSET_BUCKET, Key: key };

  s3.deleteObject(params, function (err: any, data: any) {
    if (err) {
      console.log("REACT_APP_AWS_REGION - err", err);  
    }
    else {
      return true
    }


  });



};

